"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function DeliveryAdminUIRowFromJSON(json) {
    return DeliveryAdminUIRowFromJSONTyped(json, false);
}
exports.DeliveryAdminUIRowFromJSON = DeliveryAdminUIRowFromJSON;
function DeliveryAdminUIRowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carrier': !runtime_1.exists(json, 'carrier') ? undefined : json['carrier'],
        'community': !runtime_1.exists(json, 'community') ? undefined : json['community'],
        'contentNotes': !runtime_1.exists(json, 'contentNotes') ? undefined : json['contentNotes'],
        'currentStatus': !runtime_1.exists(json, 'currentStatus') ? undefined : json['currentStatus'],
        'delivered': !runtime_1.exists(json, 'delivered') ? undefined : json['delivered'],
        'deliveryAddress': !runtime_1.exists(json, 'deliveryAddress') ? undefined : json['deliveryAddress'],
        'deliveryId': !runtime_1.exists(json, 'deliveryId') ? undefined : json['deliveryId'],
        'desiredDeliveryTimeEnd': !runtime_1.exists(json, 'desiredDeliveryTimeEnd') ? undefined : json['desiredDeliveryTimeEnd'],
        'desiredDeliveryTimeStart': !runtime_1.exists(json, 'desiredDeliveryTimeStart') ? undefined : json['desiredDeliveryTimeStart'],
        'lastStatusUpdate': !runtime_1.exists(json, 'lastStatusUpdate') ? undefined : json['lastStatusUpdate'],
        'orderNotes': !runtime_1.exists(json, 'orderNotes') ? undefined : json['orderNotes'],
        'ordered': !runtime_1.exists(json, 'ordered') ? undefined : json['ordered'],
        'packed': !runtime_1.exists(json, 'packed') ? undefined : json['packed'],
        'pickedUp': !runtime_1.exists(json, 'pickedUp') ? undefined : json['pickedUp'],
        'pickupAddress': !runtime_1.exists(json, 'pickupAddress') ? undefined : json['pickupAddress'],
        'purchaseOrderId': !runtime_1.exists(json, 'purchaseOrderId') ? undefined : json['purchaseOrderId'],
        'purchaseOrderItems': !runtime_1.exists(json, 'purchaseOrderItems') ? undefined : json['purchaseOrderItems'],
        'received': !runtime_1.exists(json, 'received') ? undefined : json['received'],
        'receiver': !runtime_1.exists(json, 'receiver') ? undefined : json['receiver'],
        'receiverId': !runtime_1.exists(json, 'receiverId') ? undefined : json['receiverId'],
        'senderShopId': !runtime_1.exists(json, 'senderShopId') ? undefined : json['senderShopId'],
        'shopName': !runtime_1.exists(json, 'shopName') ? undefined : json['shopName'],
        'shopOrderId': !runtime_1.exists(json, 'shopOrderId') ? undefined : json['shopOrderId'],
        'size': !runtime_1.exists(json, 'size') ? undefined : json['size'],
        'statusHistory': !runtime_1.exists(json, 'statusHistory') ? undefined : json['statusHistory'],
        'trackingCode': !runtime_1.exists(json, 'trackingCode') ? undefined : json['trackingCode'],
        'transportNotes': !runtime_1.exists(json, 'transportNotes') ? undefined : json['transportNotes'],
        'weight': !runtime_1.exists(json, 'weight') ? undefined : json['weight'],
    };
}
exports.DeliveryAdminUIRowFromJSONTyped = DeliveryAdminUIRowFromJSONTyped;
function DeliveryAdminUIRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carrier': value.carrier,
        'community': value.community,
        'contentNotes': value.contentNotes,
        'currentStatus': value.currentStatus,
        'delivered': value.delivered,
        'deliveryAddress': value.deliveryAddress,
        'deliveryId': value.deliveryId,
        'desiredDeliveryTimeEnd': value.desiredDeliveryTimeEnd,
        'desiredDeliveryTimeStart': value.desiredDeliveryTimeStart,
        'lastStatusUpdate': value.lastStatusUpdate,
        'orderNotes': value.orderNotes,
        'ordered': value.ordered,
        'packed': value.packed,
        'pickedUp': value.pickedUp,
        'pickupAddress': value.pickupAddress,
        'purchaseOrderId': value.purchaseOrderId,
        'purchaseOrderItems': value.purchaseOrderItems,
        'received': value.received,
        'receiver': value.receiver,
        'receiverId': value.receiverId,
        'senderShopId': value.senderShopId,
        'shopName': value.shopName,
        'shopOrderId': value.shopOrderId,
        'size': value.size,
        'statusHistory': value.statusHistory,
        'trackingCode': value.trackingCode,
        'transportNotes': value.transportNotes,
        'weight': value.weight,
    };
}
exports.DeliveryAdminUIRowToJSON = DeliveryAdminUIRowToJSON;
